import { canUseOrders } from "./orderEnabled";

/** Approval memos (pieces sent to a buyer on approval). Off unless the build turns it on; always on locally. */
export const isSalesApprovalEnabled = (): boolean =>
  process.env.REACT_APP_SALES_APPROVAL_ENABLED === "true" || process.env.REACT_APP_ENV === "loc";

export const canUseSalesApproval = (role?: string): boolean => isSalesApprovalEnabled() && canUseOrders(role);
